import clsx from "clsx";
import { SignalContext } from "context/SignalContext";
import { useContext, useRef, useState } from "react";
import {
  Svg10sBackward,
  Svg10sForward,
  SvgFullscreen,
  SvgPause,
  SvgPlay,
  SvgSd,
  SvgHd,
  SvgSnapshot,
  SvgDownload,
  SvgAudioMuted,
  SvgAudioUnMuted,
  Svg1X,
  Svg05X,
  Svg2X,
  Svg4X,
  SvgArchive,
  SvgSeachImg,
  SvgDateSelection,
} from "ui/svgs";
import { formatContextDate } from "lib/utils";
import { Popover } from "react-tiny-popover";
import "./playbackControlBar.scss";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import DownloadModal from "ui/playback/download-create-modal";
import ArchiveModal from "ui/playback/archive-create-modal";
import { Dropdown, Tooltip } from "antd";
import { showToast } from "ui/components/common";
import ImgSearchModalControl from "ui/alerts/img-search/img-search-modal-control";
import Calendar from "pages/dashboard/schedule/components/calendar";
export default function PlaybackControlBar({
  refPlayerContainer = null,
  refPlayback = null,
  refCameraPlayer = null,
  streamingCameraPlayback,
  progressTime = 0,
  cameraExpired = false,
  startAtTimeline = 0,
  timelineInterval = 1,
  onTimelineIntervalChange = (v) => {},
  pause = false,
  onPauseChange = (v) => {},
  streamId = 1,
  onStreamIdChange = (v) => {},
  audioMuted = false,
  onAudioMutedChange = (v) => {},
  playSpeed = 1,
  onPlaySpeedChange = (v) => {},
  datePickerValue = null,
  onDatePickerValueChange = (v) => {},
  onDatePickerMonthChange = (v) => {},
  onDatePickerYearChange = (v) => {},
  recordedDates = [],
  disabledButtonList = [],
  height = "60",
}) {
  const [imgSearchModalOpen, setImgSearchModalOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [isDatePopoverOpen, setIsDatePopoverOpen] = useState(false);
  const [stagedDate, setStagedDate] = useState<Date>(datePickerValue);
  const refDatePicker = useRef(null);
  const { sessionId } = useContext(SignalContext);
  function handleFullscreen() {
    const elem = refPlayerContainer.current;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      // Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      // Chrome, Safari, and Opera
      elem.webkitRequestFullscreen();
    }
  }
  function handleTimelineIntervalChanged(timelineInterval: number) {
    onTimelineIntervalChange(timelineInterval);
    setIsPopoverOpen(false);
  }
  function handlePauseResume() {
    onPauseChange(!pause);
  }
  function onBackForwardControl(offset: number) {
    refPlayback.current?.handleSeekOffset(offset);
  }
  function handle10sBack() {
    onBackForwardControl(-10);
  }

  function handle10sForward() {
    onBackForwardControl(10);
  }

  function handleAudioMuted() {
    onAudioMutedChange(!audioMuted);
  }
  function handleSnapShot() {
    if (!refCameraPlayer.current) return;
    refCameraPlayer.current.takeSnapshots();
  }
  function speedChange(speed) {
    refCameraPlayer?.current?.onPlaySpeedChange(speed, (error, data) => {
      console.log("speedChange", error, data);
      if (!data.error) {
        onPlaySpeedChange(speed);
      }
    });
  }
  function renderSpeedIcon() {
    switch (playSpeed) {
      case 0.5:
        return <Svg05X />;
      case 1:
        return <Svg1X />;
      case 2:
        return <Svg2X />;
      case 4:
        return <Svg4X />;
    }
  }

  const recordedDatesMap = recordedDates.reduce((acc, date) => {
    const key = dayjs(date).format("YYYYMMDD");
    acc.set(key, [1]);
    return acc;
  }, new Map<string, number[]>());

  return (
    <div className=" bg-zinc-100 rounded-2xl">
      <div
        className={clsx("flex flex-wrap justify-center gap-4")}
        style={{ height }}
      >
        {!disabledButtonList.includes("pause") && (
          <Tooltip title={pause ? "Play" : "Pause"}>
            <button
              style={{ height }}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
              onClick={handlePauseResume}
            >
              {pause ? (
                <SvgPlay width="28" className="fill-neutral-800" />
              ) : (
                <SvgPause width="28" className="fill-neutral-800" />
              )}
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("fastTimeChange") && (
          <>
            <Tooltip title={"10s Backward"}>
              <button
                style={{ height }}
                className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
                onClick={handle10sBack}
              >
                <Svg10sBackward width="28" className="fill-neutral-800" />
              </button>
            </Tooltip>
            <Tooltip title={"10s Forward"}>
              <button
                style={{ height }}
                className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
                onClick={handle10sForward}
              >
                <Svg10sForward width="28" className="fill-neutral-800" />
              </button>
            </Tooltip>
          </>
        )}

        {!disabledButtonList.includes("speedChange") &&
          !streamingCameraPlayback?.nvr?.isTrailer && (
            <Dropdown
              menu={{
                items: [
                  {
                    label: "0.5x",
                    key: 1,
                    onClick: () => speedChange(0.5),
                  },
                  {
                    label: "1x",
                    key: 2,
                    onClick: () => speedChange(1),
                  },
                  {
                    label: "2x",
                    key: 3,
                    onClick: () => speedChange(2),
                  },
                  {
                    label: "4x",
                    key: 4,
                    onClick: () => speedChange(4),
                  },
                ],
              }}
              placement="top"
              arrow
            >
              <button
                style={{ height }}
                className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
                onClick={handle10sForward}
              >
                {renderSpeedIcon()}
              </button>
            </Dropdown>
          )}
        {!disabledButtonList.includes("resolutionChange") && (
          <Tooltip title={streamId === 0 ? "Switch to SD" : "Switch to HD"}>
            <button
              style={{ height }}
              className={clsx(
                "w-[60px] h-[60px] flex items-center justify-center rounded-xl ",
                streamingCameraPlayback?.capabilities?.streamNum > 1
                  ? "hover:bg-zinc-200"
                  : "hover:bg-transparent cursor-not-allowed",
              )}
              onClick={onStreamIdChange}
            >
              {streamId === 0 ? (
                <SvgHd
                  width="28"
                  className={clsx(
                    streamingCameraPlayback?.capabilities?.streamNum > 1
                      ? "fill-neutral-800"
                      : "fill-neutral-400",
                  )}
                />
              ) : (
                <SvgSd width="28" className="fill-neutral-800" />
              )}
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("audioMuted") && (
          <Tooltip title={"Mute"}>
            <button
              style={{ height }}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
              onClick={handleAudioMuted}
            >
              {audioMuted ? (
                <SvgAudioMuted width="28" className={"fill-neutral-800"} />
              ) : (
                <SvgAudioUnMuted width="28" className={"fill-neutral-800"} />
              )}
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("snapshot") && (
          <Tooltip title={"Snapshot"}>
            <button
              style={{ height }}
              onClick={handleSnapShot}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
            >
              <SvgSnapshot width="28" className="fill-neutral-800" />
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("fullscreen") && (
          <Tooltip title={"Full Screen"}>
            <button
              style={{ height }}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
              onClick={handleFullscreen}
            >
              <SvgFullscreen width="28" className="fill-neutral-800" />
            </button>
          </Tooltip>
        )}

        {!disabledButtonList?.includes("imgSearch") && (
          <Tooltip title={"Image Search"}>
            <button
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:opacity-25"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setImgSearchModalOpen(true);
              }}
            >
              <SvgSeachImg width={28} />
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("download") && (
          <Tooltip title={"Download"}>
            <button
              style={{ height }}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200"
              onClick={() => {
                //@ts-ignore
                if (window.__downloadReadOnly) {
                  showToast(
                    1,
                    "please switch to another page to download,there will be only one page is able to operate download task",
                  );
                } else {
                  setDownloadModalOpen(true);
                }
              }}
            >
              <SvgDownload
                width="28"
                className={
                  //@ts-ignore
                  window.__downloadReadOnly
                    ? "fill-neutral-400"
                    : "fill-neutral-800"
                }
              />
            </button>
          </Tooltip>
        )}
        {!disabledButtonList.includes("archive") && (
          <Tooltip title={cameraExpired ? "No Licene" : "Archive"}>
            <button
              style={{ height }}
              className="w-[60px] h-[60px] flex items-center justify-center rounded-xl hover:bg-zinc-200 fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
              disabled={cameraExpired}
              onClick={() => {
                setArchiveModalOpen(true);
              }}
            >
              <SvgArchive width="22" />
            </button>
          </Tooltip>
        )}

        {!disabledButtonList.includes("timelineInterval") && (
          <Popover
            isOpen={isPopoverOpen}
            positions={["top", "bottom", "left", "right"]} // preferred positions by priority
            onClickOutside={() => setIsPopoverOpen(false)} // handle click events outside of the popover/target here!
            content={
              <div className="border rounded-xl shadow-xl bg-white min-w-44">
                <button
                  className={clsx(
                    "block w-full hover:bg-neutral-100 p-2",
                    timelineInterval === 1 && "bg-blue-100",
                  )}
                  onClick={() => {
                    handleTimelineIntervalChanged(1);
                  }}
                >
                  <p className="text-sm text-left">1 hr</p>
                </button>
                <button
                  className={clsx(
                    "block w-full hover:bg-neutral-100 p-2",
                    timelineInterval === 3 && "bg-blue-100",
                  )}
                  onClick={() => {
                    handleTimelineIntervalChanged(3);
                  }}
                >
                  <p className="text-sm text-left">3 hr</p>
                </button>
                <button
                  className={clsx(
                    "block w-full hover:bg-neutral-100 p-2",
                    timelineInterval === 12 && "bg-blue-100",
                  )}
                  onClick={() => {
                    handleTimelineIntervalChanged(12);
                  }}
                >
                  <p className="text-sm text-left">12 hr</p>
                </button>
                <button
                  className={clsx(
                    "block w-full hover:bg-neutral-100 p-2",
                    timelineInterval === 24 && "bg-blue-100",
                  )}
                  onClick={() => {
                    handleTimelineIntervalChanged(24);
                  }}
                >
                  <p className="text-sm text-left">24 hr</p>
                </button>
              </div>
            }
          >
            <div className="h-[60px] flex items-center">
              <button
                className="flex items-center rounded-xl hover:bg-zinc-200 border border-neutral-400 px-3 py-2 min-w-44 h-[33px]"
                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
              >
                <p className="text-sm font-semibold text-left">
                  Timeline Interval: {timelineInterval} hr
                </p>
              </button>
            </div>
          </Popover>
        )}
        {!disabledButtonList.includes("datePicker") && (
          <div className="h-[60px] flex items-center">
            {/* <DatePicker
              className="bg-zinc-100 border border-neutral-400 px-3 py-2 text-sm text-center font-semibold rounded-xl w-40"
              selected={datePickerValue}
              onChange={onDatePickerValueChange}
              onMonthChange={onDatePickerMonthChange}
              onYearChange={onDatePickerYearChange}
              // showTimeSelect
              showTimeInput
              // customTimeInput={<ExampleCustomTimeInput value={datePickerValue} onChange={(date) => setDatePickerValue(date)} />}
              // timeIntervals={5}
              timeInputLabel="Start Time:"
              showIcon
              highlightDates={[{ "border-b-2 border-blue-500": recordedDates }]}
              // highlightDates={recordedDates}
              dateFormat="EEE, MMM d, yyyy"
              ref={refDatePicker}
              key={sessionId}
            /> */}
            <Popover
              isOpen={isDatePopoverOpen}
              positions={["top", "left", "right"]} // preferred positions by priority
              onClickOutside={() => setIsDatePopoverOpen(false)}
              content={
                <div className="datepickPopover border rounded-xl shadow-xl bg-white w-[320px] p-4">
                  <Calendar
                    onChange={(date: dayjs.Dayjs) => {
                      setStagedDate(date.toDate());
                    }}
                    showTime={true}
                    defaultDate={dayjs(datePickerValue)}
                    shifts={recordedDatesMap}
                    children={null}
                  />
                  <div className="flex justify-end space-x-2 mt-4">
                    <button
                      className="px-4 py-2 rounded text-sm text-blue-700 hover:bg-gray-100"
                      onClick={() => {
                        setIsDatePopoverOpen(false);
                        setStagedDate(datePickerValue);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 rounded text-sm text-blue-700 hover:bg-blue-200"
                      onClick={() => {
                        setIsDatePopoverOpen(false);
                        onDatePickerValueChange(stagedDate);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              }
            >
              <div className="h-[60px] flex items-center">
                <button
                  className="flex items-center rounded-xl hover:bg-zinc-200 border border-neutral-400 px-3 py-2 w-[135px] h-[33px]"
                  onClick={() => setIsDatePopoverOpen(!isDatePopoverOpen)}
                >
                  <SvgDateSelection width="20" className="fill-blue-500" />
                  <span className="text-sm font-semibold text-left flex-grow text-nowrap">
                    {formatContextDate(datePickerValue.getTime(), {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </button>
              </div>
            </Popover>
          </div>
        )}
      </div>
      {streamingCameraPlayback && (
        <DownloadModal
          modalOpen={downloadModalOpen}
          setModalOpen={setDownloadModalOpen}
          startAt={Math.floor(startAtTimeline / 1000)}
          streamingCameraPlayback={streamingCameraPlayback}
        />
      )}
      {streamingCameraPlayback && (
        <ArchiveModal
          modalOpen={archiveModalOpen}
          setModalOpen={setArchiveModalOpen}
          startAt={Math.floor(startAtTimeline / 1000)}
          streamingCameraPlayback={streamingCameraPlayback}
        />
      )}
      <ImgSearchModalControl
        title="Upload Image"
        isOpen={imgSearchModalOpen}
        onRequestClose={() => setImgSearchModalOpen(false)}
      />
    </div>
  );
}
